import type Owner from '@ember/owner';

import moment from 'moment';

import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { Args } from 'webapp/components/popup/inner/modal';
import UserPopupInvitePromoBaseComponent from 'webapp/components/user/popup-invite-promo-base';

export default class UserPopupInvitePromoBoardComponent extends UserPopupInvitePromoBaseComponent {
	constructor(owner: Owner, args: Args) {
		super(owner, args);

		void this.userSettingsService.save(
			UserSettingsKey.INVITE_USER_BOARD_PROMO_POPUP_SHOWN_TIMESTAMP,
			moment().unix(),
		);

		this.analyticsService.event(TrackingEvent.INVITE_USER_PROMO_SHOWN, {
			type: 'databoard',
		});
	}

	get image() {
		return '/images/svg/invite-users-promo-board.svg';
	}

	get title() {
		return "Which teammate would find value in viewing the dashboards you've created?";
	}
}
